import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-[440px] mx-auto px-6 py-20" data-testid="login-page">
      <div className="font-mono-label text-primary">Sign in</div>
      <h1 className="font-serif-display text-5xl mt-3 font-light leading-none tracking-tighter">Welcome back.</h1>
      <p className="mt-4 text-muted-foreground">Pick up where you left off.</p>
      <form onSubmit={submit} className="mt-10 space-y-5">
        <div>
          <label className="font-mono-label text-muted-foreground block mb-2">Email</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-white border border-border px-4 py-3 outline-none focus:border-primary"
            style={{ borderRadius: 2 }}
            data-testid="login-email"
          />
        </div>
        <div>
          <label className="font-mono-label text-muted-foreground block mb-2">Password</label>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-white border border-border px-4 py-3 outline-none focus:border-primary"
            style={{ borderRadius: 2 }}
            data-testid="login-password"
          />
        </div>
        <button type="submit" disabled={loading} className="btn-oxblood w-full disabled:opacity-50" data-testid="login-submit">
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
      <div className="mt-6 text-sm text-muted-foreground">
        New here? <Link to="/signup" className="text-primary hover:underline" data-testid="login-signup-link">Create an account</Link>
      </div>
    </div>
  );
}
